export default __webpack_public_path__ + "static/workflowAutomationBg2-3055c88e2ec0e5d5c3f7dd139fdfe25e.png";